/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class SecurityEventApiService {

    /**
     * Generate token
     * @returns any Success
     * @throws ApiError
     */
    public static generateSecurityEventApiJwtToken({
        requestBody,
    }: {
        requestBody: {
            expirationDate?: string;
        },
    }): CancelablePromise<{
        jwtToken: string;
        securityEventApiUrl: string;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/securityEventApi/jwt',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }

    /**
     * Get Security Api Integration
     * @returns any Success
     * @throws ApiError
     */
    public static getSecurityApiIntegration(): CancelablePromise<{
        jwtToken?: string | null;
        securityEventApiUrl: string;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/securityEventApi/jwt',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

}
